<script>
export default {
  next(bus) {
    if (bus == null) return
    bus.emit('advance-flow')
  },
  back(bus) {
    if (bus == null) return
    bus.emit('recede-flow')
  },
  initiatePublish(bus) {
    if (bus == null) return
    bus.emit('initiate-publish')
  },
}
</script>
